import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на получение информации о посте
//------------------------------------------------------------------------------
export const reportPost = async ({ object_id, content_type, reason }) => {
  try{
    const data = { object_id, content_type, reason };
    const url = `${backendUrl}/api/alpha/report/`;
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при отправке жалобы на пост: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка отправки жалобы:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx